import interceptor from '@/common/interceptor';
import type { ApiResponse } from '@/apis/types';

export interface SlackConnectionStatus {
  setup_enabled: boolean;
  connected: boolean;
  status: 'legacy' | 'connected' | 'disconnected' | 'reconnect_required';
  workspace_name: string;
  channel_name: string;
  pending: {
    id: string;
    workspace_id: string;
    workspace_name: string;
    channel_id: string;
    channel_name: string;
  } | null;
}

export type SlackConnectionAction =
  | { action: 'invite'; workspace_id?: string }
  | { action: 'confirm'; invite_id: string }
  | { action: 'cancel' | 'disconnect' | 'test' };

const path = (teamId: string) => `/auth/teams/${teamId}/slack/`;

export const getSlackConnection = (
  token: string,
  teamId: string
): Promise<ApiResponse<SlackConnectionStatus>> =>
  interceptor.axiosGet('Get', path(teamId), token, null);

export const updateSlackConnection = (
  token: string,
  teamId: string,
  action: SlackConnectionAction
): Promise<ApiResponse<{ installation_url?: string }>> =>
  interceptor.axiosPost('Post', path(teamId), action, token);
